import { render, staticRenderFns } from "./LogoFinerFoodsBranca.vue?vue&type=template&id=74c811a7"
import script from "./LogoFinerFoodsBranca.vue?vue&type=script&lang=js"
export * from "./LogoFinerFoodsBranca.vue?vue&type=script&lang=js"
import style0 from "./LogoFinerFoodsBranca.vue?vue&type=style&index=0&id=74c811a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports